module.exports = __webpack_public_path__ + "img/shade.46b8e921.png";